import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import React, { useEffect, useState } from "react";

const Select2TypeCom = ({ data, value, setValue }) => {
  const [localValue, setLocalValue] = useState(null);

  useEffect(() => {
    // Sync local value with prop value
    setLocalValue(value || null);
  }, [value]);

  if (!data || data.length === 0)
    return <div className="text-muted">No Type of Component</div>;

  const type_com = data.map((item) => ({
    value: item?.id,
    label: item?.name,
    desc: item?.descr,
  }));

  // Find the selected option object based on the value
  // Support both object {value, label} and primitive value
  const selectedOption = localValue
    ? typeof localValue === "object" && localValue.value !== undefined
      ? type_com.find((option) => option.value === localValue.value)
      : type_com.find((option) => option.value === localValue)
    : null;

  const handleChange = (selectedOption) => {
    // Save as object {value, label} instead of just value
    const newValue = selectedOption
      ? {
          value: selectedOption.value,
          label: selectedOption.label,
          desc: selectedOption.desc,
        }
      : null;
    setLocalValue(newValue);
    setValue(newValue);
  };

  const CustomMultiValue = (props) => {
    return (
      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "11px",
        }}
      >
        <span className="font-weight-bold">{props.data.label}</span>
      </div>
    );
  };

  // Custom ValueContainer untuk wrap selected value seperti multi-select
  const CustomValueContainer = ({ children, ...props }) => {
    try {
      return (
        <components.ValueContainer {...props}>
          {props.hasValue && selectedOption ? (
            <CustomMultiValue data={selectedOption} />
          ) : (
            children
          )}
        </components.ValueContainer>
      );
    } catch (error) {
      console.log(error);
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );
    }
  };

  return (
    <CreatableSelect
      isMulti={false}
      isSearchable
      isClearable
      value={selectedOption}
      onChange={handleChange}
      options={type_com}
      placeholder="Select Type..."
      className="react-select-container"
      classNamePrefix="react-select"
      styles={{
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
          flexWrap: "wrap",
        }),
        input: (base) => ({
          ...base,
          margin: "0px",
        }),
      }}
      components={{
        ValueContainer: CustomValueContainer,
        IndicatorSeparator: () => null,
      }}
      formatOptionLabel={(option) => (
        <div style={{ minHeight: "auto" }}>
          <div className="font-weight-bold">{option.label}</div>
          {option.desc && (
            <div
              className="text-dark small"
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.4",
              }}
            >
              {option.desc}
            </div>
          )}
        </div>
      )}
      noOptionsMessage={() => "No type of component found"}
    />
  );
};

const Select2CPMK = ({ arr_data, data, setData, isMulti = false }) => {
  const options = arr_data.map((item) => ({
    value: item?.id,
    label: `${item?.cpmk?.code} - ${item?.cpmk?.var1}`,
    code: item?.cpmk?.code,
    desc: item?.cpmk?.var1,
    bloom_level: item?.bloom?.level,
    bloom_verb: item?.bloom?.var1,
  }));
  const [selectedOption, setSelectedOption] = useState(() => {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      return isMulti ? [] : null;
    }

    if (isMulti && Array.isArray(data)) {
      return options.filter((option) => data.includes(option.value));
    }

    return options.find((option) => option.value === data) || null;
  });

  useEffect(() => {
    if (!data || (Array.isArray(data) && data.length === 0)) {
      setSelectedOption(isMulti ? [] : null);
    } else if (isMulti && Array.isArray(data)) {
      const selected = options.filter((option) => data.includes(option.value));
      setSelectedOption(selected);
    } else {
      const selected = options.find((option) => option.value === data);
      setSelectedOption(selected || null);
    }
  }, [data, arr_data]);

  const handleChange = (selectedValue) => {
    if (selectedValue) {
      if (isMulti) {
        const values = selectedValue.map((item) => item.value);
        setData(values);
        setSelectedOption(selectedValue);
      } else {
        setData(selectedValue.value);
        setSelectedOption(selectedValue);
      }
    } else {
      setData(isMulti ? [] : null);
      setSelectedOption(isMulti ? [] : null);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      borderColor: "#e4e6ef",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e4e6ef",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#3f4254",
      fontWeight: "500",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#3f4254",
      ":hover": {
        backgroundColor: "#f64e60",
        color: "white",
      },
    }),
  };

  const CustomMultiValue = (props) => {
    return (
      <div
        className="bg-light-primary"
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "4px",
          padding: "2px 8px",
          margin: "2px",
          fontSize: "10px",
        }}
      >
        <span className="font-weight-bold">{props.data.code}</span>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            props.removeProps.onClick();
          }}
          style={{
            marginLeft: "6px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "0",
            display: "flex",
            alignItems: "center",
            color: "#6c757d",
            fontSize: "18px",
            lineHeight: "1",
          }}
        >
          ×
        </button>
      </div>
    );
  };

  // Custom ValueContainer untuk wrap selected values
  const CustomValueContainer = ({ children, ...props }) => {
    try {
      return (
        <components.ValueContainer {...props}>
          {props.hasValue && selectedOption ? (
            isMulti ? (
              // Untuk multiple selection
              <>
                {Array.isArray(selectedOption) &&
                  selectedOption.map((option, index) => (
                    <CustomMultiValue
                      key={index}
                      data={option}
                      removeProps={{
                        onClick: () => {
                          const newSelected = selectedOption.filter(
                            (item) => item.value !== option.value,
                          );
                          handleChange(
                            newSelected.length > 0 ? newSelected : null,
                          );
                        },
                      }}
                    />
                  ))}
                {children}
              </>
            ) : (
              // Untuk single selection
              <CustomMultiValue data={selectedOption} />
            )
          ) : (
            children
          )}
        </components.ValueContainer>
      );
    } catch (error) {
      console.log(error);
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );
    }
  };

  return (
    <CreatableSelect
      isMulti
      isSearchable
      isClearable
      value={selectedOption}
      onChange={handleChange}
      options={options}
      placeholder="Choose one..."
      className="react-select-container"
      classNamePrefix="react-select"
      styles={{
        ...customStyles,
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
          flexWrap: "wrap",
        }),
        input: (base) => ({
          ...base,
          margin: "0px",
        }),
      }}
      components={{
        ValueContainer: CustomValueContainer,
        IndicatorSeparator: () => null,
        ...(isMulti && { MultiValue: () => null }),
      }}
      formatOptionLabel={(option) => (
        <div style={{ minHeight: "auto" }}>
          <div className="d-lg-flex align-items-center justify-content-between">
            <div className="font-weight-bold">{option.code}</div>
            <span className="bg-light p-1 text-dark rounded-pill px-2" style={{fontSize:10}}>{option?.bloom_verb || '-'}</span>
          </div>
          
          {option.desc && (
            <div
              className="text-dark small"
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.4",
              }}
            >
              {option.desc}
            </div>
          )}
        </div>
      )}
      noOptionsMessage={() => "No CPMK found"}
    />
  );
};

const HandlerInputCPMK = (value, id, setScoreComp) => {
  setScoreComp((currentItems) => {
    const updatedItems = currentItems.map((item) => {
      if (item.wg_com_id === id) {
        return { ...item, cpmk: value };
      }
      return item;
    });

    return updatedItems;
  });
};

export { Select2TypeCom, Select2CPMK };
